import React from 'react';

import { Field } from 'formik';
import { connect } from 'react-redux';

import DatePickerField from '../../components/DatePickerField';
import MoneyTextField from '../../components/MoneyTextField';

import { MARGIN_TOP } from '../../config/constants';
import { PURCHASE } from '../../constants/pms_purpose_of_loan';
import { CONSTRUCTION, FIX_FLIP } from '../../constants/typeOfHomeOptions';

import FlipFields from '../ExtraPanels/FlipFields';
import PurchaseFields from '../ExtraPanels/PurchaseFields';

const PurchaseDetails = ({ purpose_of_loan, type_of_loan }) => {
  const isFixAndFlip = type_of_loan === FIX_FLIP.value || type_of_loan === CONSTRUCTION.value;

  return (
    <React.Fragment>
      <Field name="purchase_price" component={MoneyTextField} label="Purchase Price" required />

      <Field
        name="purchase_date"
        component={DatePickerField}
        label="Purchase Date *"
        required
        formControlStyle={{
          style: {
            marginTop: MARGIN_TOP,
            marginBottom: 0,
            width: '100%',
          },
        }}
      />

      <Field
        name="as_is_value"
        component={MoneyTextField}
        label="As-Is-Value"
        required
        formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
      />

      {purpose_of_loan === PURCHASE.value && <PurchaseFields />}

      {isFixAndFlip && <FlipFields />}
    </React.Fragment>
  );
};

const mapState = state => {
  return {
    purpose_of_loan: state.consoleBrok1.purpose_of_loan,
    type_of_loan: state.form.accounts.type_of_loan,
  };
};

export default connect(mapState)(PurchaseDetails);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/PurchaseDetails.js